import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation, clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  driverStatus: null,
  error: null,
  id: null,
  updateManageDriverStatusResult: null
};

const route = "modules/manage/modals/createEditManageDriverStatus/redux/slice";

export const manageCreateEditManageDriverStatus = createAsyncThunk(
  "manage/createEditManageDriverStatus/createEditManageDriverStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const mutation = `
              mutation (
                  ${payload.id ? "$id: Int!," : ""}
                  $name: String!,
                  $accumulateTime: Boolean!
              ) {
                  data: ${payload.id ? "updateDriverStatus" : "createDriverStatus"} (
                      ${payload.id ? "id: $id," : ""}
                      name: $name,
                      accumulateTime: $accumulateTime
                  ) {
                      id
                  }
              }
          `;
      const response = await clientMutation(mutation, payload, endpoints.GRAPHQL_GENERAL_V2);
      return response?.data;
    } catch (exc) {
      ExceptionManager(exc, route, "manageCreateEditManageDriverStatus");
      return rejectWithValue(exc);
    }
  }
);

const manageCreateEditManageDriverStatusRedux = createSlice({
  name: "manage/createEditManageDriverStatus",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
    },
    openModalCreateEditManageDriverStatus(state, action) {
      state.open = true;
      state.driverStatus = action?.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageCreateEditManageDriverStatus
    builder.addCase(manageCreateEditManageDriverStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageCreateEditManageDriverStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.updateManageDriverStatusResult = action.payload;
    });
    builder.addCase(manageCreateEditManageDriverStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageCreateEditManageDriverStatusRedux;

// Extract and export each action creator by name
export const { reset, openModalCreateEditManageDriverStatus } = actions;

// Export the reducer, either as a default or named export
export default reducer;
